"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var GlobalState_1 = __importDefault(require("./GlobalState"));
var GlobalStateController = /** @class */ (function () {
    function GlobalStateController(initialState) {
        var _this = this;
        this._globalState = new GlobalState_1.default(initialState, function (prevState) { return _this._stateDidUpdate(prevState); });
    }
    Object.defineProperty(GlobalStateController.prototype, "_state", {
        get: function () {
            return this._globalState.state;
        },
        enumerable: false,
        configurable: true
    });
    GlobalStateController.prototype._updateState = function (stateUpdate) {
        return this._globalState.updateState(stateUpdate);
    };
    GlobalStateController.prototype.withState = function (Component, stateKeys) {
        return this._globalState.withState(Component, stateKeys);
    };
    /**
     * Override if needed
     */
    GlobalStateController.prototype._stateDidUpdate = function (prevState) {
    };
    return GlobalStateController;
}());
exports.default = GlobalStateController;
